@for (paragraph of paragraphs; track paragraph) {
  <div class="skeleton-paragraph" [attr.data-qa]="testId">
    @for (line of lines; track line) {
      <div class="skeleton-element"></div>
    }
  </div>
}
